export const EXCMAGREEMENTDEVICE_CREATE_RESET = 'EXCMAGREEMENTDEVICE_CREATE_RESET'
export const EXCMAGREEMENTDEVICE_CREATE_SET_CREATED = 'EXCMAGREEMENTDEVICE_CREATE_SET_CREATED'
export const EXCMAGREEMENTDEVICE_CREATE_SET_ERROR = 'EXCMAGREEMENTDEVICE_CREATE_SET_ERROR'
export const EXCMAGREEMENTDEVICE_CREATE_SET_VIOLATIONS = 'EXCMAGREEMENTDEVICE_CREATE_SET_VIOLATIONS'
export const EXCMAGREEMENTDEVICE_CREATE_TOGGLE_LOADING = 'EXCMAGREEMENTDEVICE_CREATE_TOGGLE_LOADING'
